import React from 'react';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex flex-col mb-4">
              <span className="text-3xl font-bold text-white leading-tight">
                MINI MIKE
              </span>
              <span className="text-lg font-semibold text-green-400 -mt-1">
                MOWING
              </span>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              Professional lawn mowing and garden maintenance serving Melbourne's southeast suburbs.
            </p>
            <div className="flex items-center gap-2 text-sm text-gray-400">
              <Clock className="h-4 w-4" />
              <span>24/7 messaging available</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection('hero')}
                  className="text-gray-400 hover:text-green-400 transition-colors text-sm"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-green-400 transition-colors text-sm"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('service-areas')}
                  className="text-gray-400 hover:text-green-400 transition-colors text-sm"
                >
                  Service Areas
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-green-400 transition-colors text-sm"
                >
                  About Us
                </button>
              </li>
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h3 className="text-lg font-bold mb-4">Service Areas</h3>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>Dandenong</li>
              <li>Keysborough</li>
              <li>Noble Park</li>
              <li>Springvale</li>
              <li>& Surrounding Suburbs</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-bold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li>
                <a
                  href="tel:0434600945"
                  className="flex items-center gap-2 text-gray-400 hover:text-green-400 transition-colors text-sm"
                >
                  <Phone className="h-4 w-4" />
                  0434 600 945
                </a>
              </li>
              <li className="flex items-center gap-2 text-gray-400 text-sm">
                <MapPin className="h-4 w-4" />
                Melbourne Southeast
              </li>
            </ul>
            <div className="mt-4">
              <a
                href="tel:0434600945"
                className="inline-block bg-green-600 hover:bg-green-700 text-white px-6 py-3 rounded-lg font-semibold text-sm transition-all shadow-lg hover:shadow-xl"
              >
                Call or Text Now
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              © {currentYear} Mini Mike Mowing. All rights reserved.
            </p>
            <p className="text-sm text-gray-400">
              Professional lawn mowing & garden maintenance in Dandenong, Keysborough, Noble Park & Springvale
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
